import { projectDraftPatchNumber } from "$src/application/projects/stores/projectStore";
import { ServiceTokens } from "$src/domain/ServiceTokens";
import { DraftNewPatch } from "$src/domain/projects/drafts/DraftNewPatch";
import type { IProjectDraftRepository } from "$src/domain/projects/drafts/IProjectDraftRepository";
import { PatchResult } from "$src/domain/projects/drafts/PatchResult";
import { PatchResultStatus } from "$src/domain/projects/drafts/PatchResultStatus";
import { Operation } from "fast-json-patch";
import { get } from "svelte/store";
import { inject, injectable } from "tsyringe";

@injectable()
export class PatchDraft {
    
    constructor(@inject(ServiceTokens.ProjectDraftRepository) private projectDraftRepository: IProjectDraftRepository) {}

    async execute(groupStoreId: number, projectId: number, operations:  Operation[]): Promise<PatchResult> {

        console.log('executing patch draft');

        var currentPatchNumber = get(projectDraftPatchNumber);
        var patch: DraftNewPatch = {
            patchNumber: currentPatchNumber + 1,
            patchDocument: operations,
        };
        var patchResult = await this.projectDraftRepository.PatchDraft(groupStoreId, projectId, patch);

        console.log('executing patch draft - done');

        if( patchResult.status == PatchResultStatus.Applied )
        {
            projectDraftPatchNumber.update(value => value + 1);
        }
        else if( patchResult.status == PatchResultStatus.PatchNumberMismatch )
        {
            //override ?
        }

        return patchResult;
    }
}

export const PatchDraftToken = Symbol('PatchDraftToken');